import { AxiosError } from 'axios';
import type { GetDocumentCollectionRequestType } from 'entities/document/api/types';
import { getDocumentsQueue } from './get-documents-queue';

/**
 * Synthetic request to get document queue collection
 * @param params
 */
export const getDocumentQueueCollection = async (
  params: GetDocumentCollectionRequestType,
) =>
  Promise.all(
    params.documentIds.map(async documentId => {
      try {
        const data = await getDocumentsQueue({
          documentId,
        });
        return {
          documentId,
          data,
        };
      } catch (error) {
        if (error instanceof AxiosError && error.status === 401) {
          throw error;
        }

        return {
          documentId,
          error,
        };
      }
    }),
  );
